/**
 * Search export dead letters (Super Admin) — task-urnb2ftcux.
 * Site comes from the global site selector; the panel owns the rest.
 */
import React from 'react';
import { useSite } from '@/contexts/SiteContext';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { DeadLetterRequeuePanel } from '@/components/search-export/DeadLetterRequeuePanel';

export default function SearchExportDeadLetters() {
  const { selectedSite } = useSite();
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Search Export Dead Letters</h1>
        <p className="text-muted-foreground">
          Vertex AI Search export rows that exhausted their attempts, per cohort, with a requeue-by-site control.
        </p>
      </div>
      {selectedSite?.id ? (
        <DeadLetterRequeuePanel key={selectedSite.id} siteId={selectedSite.id} siteName={selectedSite.name} />
      ) : (
        <Alert>
          <AlertTitle>Select a site</AlertTitle>
          <AlertDescription>Pick a site in the header to see its dead-lettered export rows.</AlertDescription>
        </Alert>
      )}
    </div>
  );
}
